// import React from "react";
// import styled from "styled-components";
// import {
//   FaClock,
//   FaBug,
//   FaUsers,
//   FaRocket,
//   FaMoneyBillAlt,
//   FaSmileBeam,
// } from "react-icons/fa";
// import { gradients } from "./theme/theme";

// const Section = styled.section`
//   padding: 6rem 2rem;
//   background: ${gradients.heroBackground};
//   text-align: center;
// `;

// const Title = styled.h2`
//   font-size: 2.8rem;
//   color: white;
//   margin-bottom: 3rem;
// `;

// const Grid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
//   gap: 2rem;
//   max-width: 1200px;
//   margin: 0 auto;
// `;

// const Card = styled.div`
//   border: 1px solid #333;
//   border-radius: 12px;
//   padding: 2rem;
//   text-align: left;
//   transition: background 0.3s ease;
//   display: flex;
//   gap: 1.2rem;
//   align-items: center;

//   &:hover {
//     background: ${gradients.heroBackground};
//   }
// `;

// const IconWrapper = styled.div`
//   color: ${({ theme }) => theme.orange || "#ff6b00"};
//   font-size: 2rem;
//   margin-top: 4px;
// `;

// const Content = styled.div``;

// const CardTitle = styled.h3`
//   color: #fff;
//   font-size: 1.6rem;
//   margin-bottom: 0.4rem;
// `;

// const Description = styled.p`
//   color: #ccc;
//   font-size: 0.95rem;
// `;

// export default function WhyUs() {
//   return (
//     <Section>
//       <Title>Why Choose Us?</Title>
//       <Grid>
//         <Card>
//           <IconWrapper>
//             <FaClock size={48} />
//           </IconWrapper>
//           <Content>
//             <CardTitle>Weekend Availability</CardTitle>
//             <Description>
//               We're available even on weekends and holidays to support urgent
//               client needs.
//             </Description>
//           </Content>
//         </Card>

//         <Card>
//           <IconWrapper>
//             <FaBug size={48} />
//           </IconWrapper>
//           <Content>
//             <CardTitle>Quick Issue Resolution</CardTitle>
//             <Description>
//               Our team ensures fast bug fixes and feature delivery with clear
//               communication.
//             </Description>
//           </Content>
//         </Card>

//         <Card>
//           <IconWrapper>
//             <FaUsers size={48} />
//           </IconWrapper>
//           <Content>
//             <CardTitle>Team of Industry Experts</CardTitle>
//             <Description>
//               We bring experience from top MNCs to deliver scalable and reliable
//               solutions.
//             </Description>
//           </Content>
//         </Card>

//         <Card>
//           <IconWrapper>
//             <FaRocket size={48} />
//           </IconWrapper>
//           <Content>
//             <CardTitle>Client-First Mindset</CardTitle>
//             <Description>
//               We treat every project as our own—focused on UX, scalability, and
//               business impact.
//             </Description>
//           </Content>
//         </Card>

//         <Card>
//           <IconWrapper>
//             <FaMoneyBillAlt size={48} />
//           </IconWrapper>
//           <Content>
//             <CardTitle>Competitive Pricing</CardTitle>
//             <Description>
//               High-quality development services at rates lower than market
//               standards.
//             </Description>
//           </Content>
//         </Card>

//         <Card>
//           <IconWrapper>
//             <FaSmileBeam size={48} />
//           </IconWrapper>
//           <Content>
//             <CardTitle>100% Client Satisfaction</CardTitle>
//             <Description>
//               We prioritize long-term relationships with full transparency and
//               trust.
//             </Description>
//           </Content>
//         </Card>
//       </Grid>
//     </Section>
//   );
// }

import React from "react";
import styled from "styled-components";
import {
  FaClock,
  FaBug,
  FaUsers,
  FaRocket,
  FaMoneyBillAlt,
  FaSmileBeam,
} from "react-icons/fa";
import { gradients } from "./theme/theme";

const Section = styled.section`
  padding: 6rem 2rem;
  background: ${gradients.heroBackground};
  text-align: center;
`;

const Title = styled.h2`
  font-size: 3rem;
  color: white;
  margin-bottom: 3rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(90deg, #ff7a18, #ff0066);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Card = styled.div`
  position: relative;
  padding: 2rem;
  border-radius: 16px;
  backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  text-align: left;
  display: flex;
  gap: 1.2rem;
  align-items: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-6px) scale(1.03);
    box-shadow: 0 12px 40px rgba(255, 122, 24, 0.3);
    border: 1px solid rgba(255, 122, 24, 0.4);
  }
`;

const IconWrapper = styled.div`
  background: linear-gradient(135deg, #ff7a18, #ff0066);
  color: white;
  font-size: 2rem;
  border-radius: 50%;
  padding: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 15px rgba(255, 0, 102, 0.3);
  min-width: 60px;
  min-height: 60px;
`;

const Content = styled.div``;

const CardTitle = styled.h3`
  color: #fff;
  font-size: 1.4rem;
  margin-bottom: 0.4rem;
  font-weight: 600;
`;

const Description = styled.p`
  color: #ccc;
  font-size: 0.95rem;
  line-height: 1.4;
`;

export default function WhyUs() {
  // const features = [
  //   {
  //     icon: <FaClock size={28} />,
  //     title: "Always Accessible",
  //     desc: "Whether you’re a business with urgent project needs or a learner stuck on a topic, we’re available to help—even on weekends.",
  //   },
  //   {
  //     icon: <FaBug size={28} />,
  //     title: "Fast Problem Solving",
  //     desc: "From fixing bugs in client projects to clearing coding doubts in courses, we believe in quick and practical solutions.",
  //   },
  //   {
  //     icon: <FaUsers size={28} />,
  //     title: "Experienced Mentors & Developers",
  //     desc: "Our team has real-world experience from top companies and startups—bringing industry best practices to both projects and training.",
  //   },
  //   {
  //     icon: <FaRocket size={28} />,
  //     title: "Growth-Focused Approach",
  //     desc: "For businesses, we build scalable products. For learners, we provide career-focused courses that boost skills and confidence.",
  //   },
  //   {
  //     icon: <FaMoneyBillAlt size={28} />,
  //     title: "Affordable & Transparent",
  //     desc: "We offer competitive pricing for projects and budget-friendly courses, making quality development and learning accessible to all.",
  //   },
  //   {
  //     icon: <FaSmileBeam size={28} />,
  //     title: "Trusted by Clients & Students",
  //     desc: "We value long-term relationships, ensuring client satisfaction and learner success with transparency and support.",
  //   },
  // ];
  const features = [
    {
      icon: <FaBug size={28} />,
      title: "Fast Problem Solving",
      desc: "Clear coding doubts quickly with practical, real-world solutions designed to strengthen your understanding.",
    },
    {
      icon: <FaUsers size={28} />,
      title: "Experienced Mentors",
      desc: "Learn directly from developers with real-world experience at top companies and startups.",
    },
    {
      icon: <FaRocket size={28} />,
      title: "Career-Focused Growth",
      desc: "Our courses are designed to build industry-relevant skills, boost confidence, and prepare you for opportunities.",
    },
    {
      icon: <FaMoneyBillAlt size={28} />,
      title: "Budget-Friendly Learning",
      desc: "Access high-quality, affordable courses that make skill-building easier for everyone.",
    },
    {
      icon: <FaSmileBeam size={28} />,
      title: "Trusted by Learners",
      desc: "Thousands of students trust us for transparent, supportive, and impactful learning experiences.",
    },
  ];

  return (
    <Section>
      <Title>Why Choose Us?</Title>
      <Grid>
        {features.map((f, i) => (
          <Card key={i}>
            <IconWrapper>{f.icon}</IconWrapper>
            <Content>
              <CardTitle>{f.title}</CardTitle>
              <Description>{f.desc}</Description>
            </Content>
          </Card>
        ))}
      </Grid>
    </Section>
  );
}
